/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useEffect } from "react";

import LayoutWbs from "./LpWbsComponents/LayoutWbs";
import SchufaWbsPageMeta from "./SchufaWbsPageMeta";
import WbsTeaserWithCards from "./LpWbsComponents/WbsTeaserWithCards";
import { logout } from "../../../../../store/login/actions";

const SchufaWbsPage = () => {
  useEffect(() => {
    logout();
  }, []);

  return (
    <LayoutWbs>
      <SchufaWbsPageMeta />
      <WbsTeaserWithCards
        headline={"Illegale Weitergabe von Daten aus Telekommunikationsverträgen an die SCHUFA/CRIF"}
        subHeadline={
          <>
            Danke für dein Interesse an unseren Dienstleistungen bezüglich der illegalen Datenweitergabe.
            <br />
            <br />
            In den vergangenen Jahren haben wir zahlreiche Mandanten erfolgreich bei der Durchsetzung ihrer Rechte wegen unzulässiger Datenweitergabe
            unterstützt.
            <br />
            <br />
            <b>Ein wesentlicher Erfolg war dabei die Löschung unberechtigter Einträge bei Auskunfteien wie der SCHUFA oder CRIF.</b>
            <br />
            <br />
            Aufgrund der aktuellen Rechtsprechung, die sich zunehmend nachteilig für Betroffene entwickelt, nehmen wir derzeit keine neuen Mandate in diesem
            Bereich mehr an.
            <br />
            <br />
            Vielen Dank für Dein Verständnis.
          </>
        }
        hasTeaserButton={false}
      />
    </LayoutWbs>
  );
};

export default SchufaWbsPage;
